import { useState, useEffect } from 'react'
import { MessageCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetTitle,
} from '@/components/ui/sheet'
import { SupportChat } from './SupportChat'

export const OPEN_SUPPORT_CHAT_EVENT = 'rtg-open-support-chat'

export function SupportChatPopup() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handler = () => setOpen(true)
    window.addEventListener(OPEN_SUPPORT_CHAT_EVENT, handler)
    return () => window.removeEventListener(OPEN_SUPPORT_CHAT_EVENT, handler)
  }, [])

  return (
    <>
      {/* Botão flutuante — canto inferior direito, identidade verde */}
      <Button
        onClick={() => setOpen(true)}
        aria-label="Abrir chat de suporte"
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full text-white shadow-lg transition-all duration-200 hover:scale-105 hover:opacity-90"
        style={{ backgroundColor: "#25D366", boxShadow: "0 4px 14px rgba(37, 211, 102, 0.4)" }}
      >
        <MessageCircle className="h-6 w-6" />
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="right"
          className="support-chat-sheet w-full sm:max-w-md p-0 flex flex-col h-full max-h-[100dvh]"
          aria-describedby={undefined}
        >
          <SheetTitle className="sr-only">Chat de suporte</SheetTitle>
          <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
            <SupportChat />
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}
